/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

/**
 * Initialize and return a Date object using a Unix timestamp
 * 
 * @param {Number} d 
 */
export function epochToDate(d) {
    let dDate = new Date(0);
    dDate.setUTCSeconds(d);

    return dDate;
}

/**
 * Get the amount of days since d, a date in Epoch
 * 
 * @param {Number} d 
 */
export function getDaysSince(d) {
    const now = new Date();

    const dDate = epochToDate(d);

    if (dDate > now) {
        return 0;
    }

    return dateDiffDays(now, dDate);
}

/**
 * Get the amount of days until d, a date in Epoch
 * 
 * @param {Number} d 
 */
export function getDaysUntil(d) {
    const now = new Date();

    const dDate = epochToDate(d);

    if (now > dDate) {
        return 0;
    }

    return dateDiffDays(now, dDate);
}

export function dateDiffDays(a, b) {
    const dateDiff = a.getTime() - b.getTime();

    const dateDiffDays = Math.ceil(dateDiff / (1000 * 3600 * 24));

    /* Whether or not a is before or after b is irrelevant. Since we simply want to know how many days are in between the two dates
     */
    return Math.abs(dateDiffDays);
}


// WEBPACK FOOTER //
// ./src/dateutils.js